import type { Application } from 'pixi.js';
import type { FpsMeter } from './debug/fpsMeter';
import type { InputController } from './input/InputController';
import type { GameRenderer } from './render/Renderer';
import type { AudioLayer } from './audio/AudioLayer';
import type { Simulation } from './sim/sim';
import type { Hud } from './ui/hud';
import type { Tutorial } from './ui/Tutorial';

/** One rAF loop: advance sim (fixed-step), fan out events, draw interpolated. */
export function startLoop(
  app: Application,
  sim: Simulation,
  renderer: GameRenderer,
  input: InputController,
  hud: Hud,
  fps: FpsMeter,
  tutorial: Tutorial | null = null,
  audio: AudioLayer | null = null,
): void {
  app.ticker.add(() => {
    const now = performance.now();
    const frame = sim.advance(now);
    input.update(app.ticker.deltaMS / 1000);
    const events = sim.drainEvents();
    if (events.length > 0) {
      renderer.handleEvents(events);
      hud.handleEvents(events);
    }
    audio?.frame(sim, events);
    renderer.draw(sim, frame.alpha, input);
    hud.update();
    tutorial?.check();
    fps.frame(now, frame.steps, frame.droppedSeconds);
  });
}
